import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ComponentBase, CustomerInfo, CustomerType } from 't4core';
import { CustomerDialog } from '../../dialogs/CustomerDialog/CustomerDialog';

@Component({
    selector: 't4-customer-link',
    templateUrl: './customerLink.html',
    styleUrls: ['./customerLink.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class T4CustomerLink extends ComponentBase implements OnInit {
    private _customerId: number;
    @Input() public displayText: string;
    @Input() public set customer(c: CustomerInfo) {
        if (c) {
            if (c.Type == CustomerType.Consumer) this.displayText = c.Lastname + ", " + c.Firstname;
            if (c.Type == CustomerType.Company) this.displayText = c.CompanyName;
        }
        this._customer = c;
  };

  public get customerId(): number { return this._customerId; }
    @Input() public set customerId(value: number) {
        if (!value) return;

        var val = parseInt(value.toString());
        if (this._customerId != val) {
            this._customerId = val;
            this.customer = undefined;
            if (this.isInitialized) this.loadCustomer();
        }
    };

    @Output() public mouseOver = new EventEmitter<CustomerInfo>();
    @Output() public mouseOut = new EventEmitter<CustomerInfo>();
    @Output() public clicked = new EventEmitter<CustomerInfo>();

    public _customer: CustomerInfo;
    public isLoading: boolean = false;
    public displayTooltip: boolean = false;
    public hidingTooltip: boolean = false;

    private isInitialized = false;

    constructor(public ChangeDetector: ChangeDetectorRef) {
        super();
    }

    public ngOnInit() {
        if (!this.displayText && !this._customer) {
            this.loadCustomer();
        }

        this.isInitialized = true;
        this.ChangeDetector.detectChanges();
    }

    private loadCustomer() {
        if (!this._customerId) return;

        this.isLoading = true;

        this.Api.get<CustomerInfo>("Rental/GetCustomerInfo", { customerId: this._customerId }).then(x => {
            this._customer = x;
            if (this._customer && !this.displayText) {
                this.displayText = this._customer.Lastname + ", " + this._customer.Firstname;
            }

            this.isLoading = false;
            this.mouseOver.emit(this._customer);
            this.ChangeDetector.detectChanges();
        });
    }

    public show() {
        this.hidingTooltip = false;
        this.displayTooltip = true;
        if (!this._customer) {
            this.loadCustomer();
        } else {
            this.mouseOver.emit(this._customer);
        }
    }

    public hide() {
        this.hidingTooltip = true;
        setTimeout(() => {
            if (this.hidingTooltip) {
                this.displayTooltip = false;
                this.mouseOut.emit(this._customer);
            }
        }, 100);
        
    }

    public async click() {

        this.clicked.emit(this._customer);

        CustomerDialog.open(this.Dialog, this._customer, this._customerId);
    }
}
